import { graphql } from './../.gql';

// export const PAYMENT_PROVIDER = graphql(`
//   query PaymentProvider {
//     getImageGenerationPacks {
//       ...TImageGenerationPack
//     }
//     getPaymentSystems {
//       ...TPaymentSystem
//     }
//   }
// `);

export const GET_IMAGE_GENERATION = graphql(`
  query getImageGeneration($imageGenerationId: String!) {
    getImageGeneration(imageGenerationId: $imageGenerationId) {
      ...TImageGeneration
    }
  }
`);

export const FIND_PAYMENT = graphql(`
  query FindPaymentProvider($paymentId: String!) {
    getPayment(paymentId: $paymentId) {
      ...TPayment
    }
  }
`);

export const GET_PROFILE = graphql(`
  query getProfile {
    getProfile {
      ...TProfile
    }
  }
`);

export const GET_STYLE_CATEGORIES = graphql(`
  query getStyleCategories {
    getStyleCategories {
      ...TStyleCategory
    }
    getPhotoSessions {
      ...TPhotoSession
    }
    getVideoLooks {
      ...TVideoLook
    }
    getVideoStyles {
      ...TVideoStyle
    }
    getCombiVideos {
      ...TCombiVideo
    }
    getTrending {
      ...TTrendingItem
    }
    getEffects {
      ...TEffect
    }
    getVideoVeo3 {
      ...TVideoVeo3
    }
  }
`);

export const GET_ME_IMAGE_GENERATIONS = graphql(`
  query getMeImageGenerations($cursor: String, $isPublished: Boolean) {
    getMeImageGenerations(cursor: $cursor, isPublished: $isPublished) {
      data {
        ...TImageGeneration
      }
      nextCursor
    }
  }
`);

export const GET_ME_VIDEO_GENERATIONS = graphql(`
  query getMeVideoGenerations($cursor: String) {
    getMeVideoGenerations(cursor: $cursor) {
      data {
        id
        video
        isPublished
        status
      }
      nextCursor
    }
  }
`);

export const GET_USER = graphql(`
  query getUser($userId: String!) {
    getUser(userId: $userId) {
      ...TUser
    }
  }
`);

export const GET_PUBLICATIONS_BY_USER_ID = graphql(`
  query getPublicationsByUserId($userId: String!, $cursor: String) {
    getPublicationsByUserId(userId: $userId, cursor: $cursor) {
      data {
        ...TPublication
      }
      nextCursor
    }
  }
`);

export const GET_SUBSCRIPTIONS = graphql(`
  query getSubscriptions($userId: String!) {
    getSubscriptions(userId: $userId) {
      ...TUser
    }
  }
`);

export const GET_SUBSCRIBERS = graphql(`
  query getSubscribers($userId: String!) {
    getSubscribers(userId: $userId) {
      ...TUser
    }
  }
`);

export const GET_ME_SUBSCRIPTIONS = graphql(`
  query getMeSubscriptions {
    getMeSubscriptions {
      ...TUser
    }
  }
`);

export const GET_ME_SUBSCRIBERS = graphql(`
  query getMeSubscribers {
    getMeSubscribers {
      ...TUser
    }
  }
`);

export const GET_PUBLICATIONS = graphql(`
  query getPublications($cursor: String) {
    getPublications(cursor: $cursor) {
      data {
        ...TPublication
        Author {
          ...TUser
        }
      }
      nextCursor
    }
  }
`);

export const GET_PUBLICATIONS_FOR_ME = graphql(`
  query getPublicationsForMe($cursor: String) {
    getPublicationsForMe(cursor: $cursor) {
      data {
        ...TPublication
        Author {
          ...TUser
        }
      }
      nextCursor
    }
  }
`);

export const GET_SAVED_PUBLICATIONS = graphql(`
  query getSavedPublications($cursor: String) {
    getSavedPublications(cursor: $cursor) {
      data {
        ...TPublication
        Author {
          ...TUser
        }
      }
      nextCursor
    }
  }
`);

export const GET_ALL_FINAL_PRICES = graphql(`
  query getAllFinalPrices {
    getAllFinalPrices {
      batchSize
      price
      isFree
      promoName
      promoId
      serviceType
      specificService
    }
  }
`);

export const GET_STORY_LINES = graphql(`
  query getStoryLines {
    getStoryLines {
      ...TStoryLine
    }
  }
`);
